/* tslint:disable:no-console */

import { register } from 'register-service-worker';

export function registerServiceWorker() {
    if (process.env.NODE_ENV === 'production') {
        // This is emulated by webpack
        console.log('ADDED SERVICE WORKER HOOK.');

        register(`${process.env.BASE_URL}service-worker.js`, {
            ready() {
                console.log('SERVICE WORKER: APP LOADED FROM CACHE');
            },
            registered() {
                console.log('SERVICE WORKER: REGISTERED');
            },
            cached() {
                console.log('SERVICE WORKER: VERSION CACHED');
            },
            updatefound() {
                console.log('SERVICE WORKER: DOWNLOADING');
            },
            updated() {
                console.log('SERVICE WORKER: RELOADING PAGE');
                window.location.reload();
            },
            offline() {
                console.log('SERVICE WORKER: OFFLINE MODE (NO INTERNET CONNECTION)');
            },
            error(error) {
                console.error('SERVICE WORKER: ERROR IN REGISTRATION', error);
            },
        });
    } else {
        console.log('SKIPPED SERVICE WORKER HOOK.');
    }
}
